import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { packages } from '../data/packages';
import { SectionHeading } from './SectionHeading';
import { PackageIconGlyph } from './PackageIconGlyph';

/** Homepage overview of the four detailing packages, each linking to its page. */
export function FeaturedServices() {
  return <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" aria-label="Featured services" data-id="element-156" data-mp="3jcmdtwe5rk11">
      <div className="max-w-7xl mx-auto" data-id="element-157" data-mp="3s6spyysdb3m5">
        <SectionHeading title="Our Detailing Services" subtitle="Professional mobile auto detailing delivered to your driveway anywhere in Ventura County." data-id="element-158" data-mp="3s5r37x1zosol" />

        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-159" data-mp="5zkmk210d6sr">
          {packages.map(pkg => {
          const accent = pkg.accent === 'blue' ? 'text-blue-400' : 'text-green-400';
          return <li key={pkg.slug} className={`relative flex flex-col bg-zinc-900/60 border rounded-xl p-6 ${pkg.popular ? 'border-green-500' : 'border-zinc-800'}`} data-id="element-160" data-mp="27r765iiklzf7">
                {pkg.popular && <span className="absolute -top-3 left-6 px-3 py-0.5 bg-green-500 text-black text-xs font-black uppercase tracking-wider rounded-full" data-id="element-161" data-mp="cc9eirzwu19x">
                    Most Popular
                  </span>}
                <PackageIconGlyph icon={pkg.icon} className={`w-7 h-7 ${accent}`} data-id="element-162" data-mp="q5h64jnzqwrm" />
                <h3 className={`mt-4 text-2xl font-black uppercase tracking-wide ${accent}`} data-id="element-163" data-mp="q7brfz36cqw8">
                  {pkg.name}
                </h3>
                <p className="mt-3 text-gray-300 leading-relaxed" data-id="element-164" data-mp="102vk8cmfz9gr">{pkg.summary}</p>
                {pkg.requirement && <p className="mt-3 text-sm font-bold text-white" data-id="element-165" data-mp="145096y1y3hx2">
                    {pkg.requirement}
                  </p>}
                <p className="mt-auto pt-6 text-sm text-gray-400" data-id="element-166" data-mp="193th8aygqgpu">
                  From{' '}
                  <span className="text-3xl font-black text-white" data-id="element-167" data-mp="35y6dqig3z9rm">
                    {pkg.priceSm}
                  </span>
                </p>
                <Link to={pkg.path} className="mt-4 flex items-center justify-center gap-2 w-full py-3 bg-red-600 hover:bg-red-500 text-white font-black text-sm uppercase tracking-wider rounded-lg transition-colors duration-150" aria-label={`View ${pkg.name} service`} data-id="element-168" data-mp="i0y83lkhz8yt">
                  View Service
                  <ArrowRight className="w-4 h-4" aria-hidden="true" data-id="element-169" data-mp="m32xg83wxjfn" />
                </Link>
              </li>;
        })}
        </ul>

        <div className="mt-10 text-center" data-id="element-170" data-mp="10z27hoal1tnf">
          <Link to="/services" className="inline-flex items-center gap-2 text-yellow-400 font-black uppercase tracking-wider hover:text-yellow-300 transition-colors duration-150" style={{
          color: "#FFE81A"
        }} data-id="element-171" data-mp="10xr2jl5eifuq">
            See all services, add-ons &amp; pricing
            <ArrowRight className="w-4 h-4" aria-hidden="true" data-id="element-172" data-mp="15s3llu2ytp5y" />
          </Link>
        </div>
      </div>
    </section>;
}